import { EventSourcePolyfill } from 'event-source-polyfill';
import { Observable } from 'rxjs';
import { server } from '../common/conf';
import { Comm } from './comm';
var comm = new Comm();
var Auth = /** @class */ (function () {
    function Auth(token) {
        var _this = this;
        if (token === void 0) { token = null; }
        this.token = token;
        this.logged = new Promise(function (resolve) {
            _this.logged_resolve = resolve;
        });
        this.observations = {};
    }
    Auth.prototype.fetchPBUF = function (url, decoder, body) {
        if (body === void 0) { body = null; }
        return fetch(server + url, {
            method: body ? 'POST' : 'GET',
            body: body && JSON.stringify(body),
            headers: {
                Authorization: this.token ? "Bearer ".concat(this.token.jwt) : "",
            },
        })
            .then(function (x) { return x.arrayBuffer(); })
            .then(function (data) { return decoder(data); });
    };
    Auth.prototype.fetchJSON = function (url, body) {
        if (body === void 0) { body = null; }
        if (!this.token) {
            return new Promise(function (resolve) { return resolve([]); });
        }
        return fetch(server + url, {
            method: body ? 'POST' : 'GET',
            body: body && JSON.stringify(body),
            headers: {
                Authorization: this.token ? "Bearer ".concat(this.token.jwt) : "",
            },
        }).then(function (x) { return x.json(); });
    };
    Object.defineProperty(Auth.prototype, "user", {
        get: function () {
            return this.token;
        },
        enumerable: false,
        configurable: true
    });
    Auth.prototype.setToken = function (token) {
        this.token = token;
        this.logged_resolve();
        comm.send({ request: 'authenticate', token: token.jwt });
    };
    Auth.prototype.getToken = function () {
        return this.token;
    };
    Auth.prototype.isLogged = function () {
        return this.token != null;
    };
    Auth.prototype.station = function (source, station) {
        // if (!this.token) return Promise.resolve({ status: "logged-out" })
        return comm.send({ request: 'station', source: source, station: station });
    };
    Auth.prototype.historic = function (source, station, specie, durationInDays) {
        var url = "".concat(server, "historic/station/").concat(source, "/").concat(station, "/").concat(specie, "?ndays=").concat(durationInDays);
        // if (this.observations[url]) return this.observations[url]
        var evt = new EventSourcePolyfill(url, {
            headers: {
                Authorization: this.token ? "Bearer ".concat(this.token.jwt) : "",
            },
        });
        var closer = function () {
            if (evt == null)
                return;
            evt.close();
            evt = null;
        };
        var obs = new Observable(function (subscriber) {
            evt.addEventListener('data', function (e) {
                var data = JSON.parse(e.data).map(function (x) { return ({
                    t: new Date(x[0] * 1000),
                    v: x[1],
                }); });
                subscriber.next(data);
            });
            evt.addEventListener('error', function (e) {
                console.log('evt oops..', e);
                subscriber.error(e);
                closer();
            });
            evt.addEventListener('meta', function (e) {
                if (e.data == '"done"') {
                    closer();
                    subscriber.complete();
                }
            });
        });
        // this.observations[url] = obs
        return {
            obs: obs,
            closer: closer,
        };
    };
    return Auth;
}());
export { Auth };
